<template>
  <b-container>

    <div style="display: flex">
      <b-breadcrumb :items="items" style="margin-top: 16px"></b-breadcrumb>
    </div>

    <div v-if="!loaded" class="text-center" style="margin-top: 64px">
      <b-spinner />
    </div>

    <div
        v-if="this.thumbnails && this.thumbnails.length == 0 && this.loaded"
        style="margin: 16px 0px"
      >
        No thumbnails were found for this hotel.
      </div>

    <b-row style="padding-top: 16px" v-if="loaded">
      <b-col
          cols="12"
          lg="3"
          v-for="thumbnail in thumbnails"
          :key="thumbnail._id"
          style="margin-bottom: 24px"
        >
        <img style="width: 100%; border-radius: 3px; border: solid 1px #eee"
        :src="thumbnail.mediumUrl"/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      thumbnails: [],
      loaded: false,
      items: [
        {
          text: "Hotels",
          href: "#/",
        },
        {
          text: `${this.$route.params.name}`,
        },
      ],
    };
  },
  async created() {
    const url = `/hotel/${this.$route.params.name}/thumbnails`
    const response = await fetch(url)
    this.thumbnails = await response.json()
    console.log(this.thumbnails)

    this.loaded = true
  },
}
</script>



// WEBPACK FOOTER //
// src/components/HotelThumbnails.vue